// extracted by mini-css-extract-plugin
module.exports = {"style":{"fontFamily":"'Cairo', 'Cairo Fallback'","fontStyle":"normal"},"className":"__className_4777dd","variable":"__variable_4777dd"};